export class MapConfig {
    public constructor(
        public latitude: number = 0,
        public longitude: number = 0,
        public zoom: number = 0,
        public accessToken: string = "",
    ) {}
}